import { Appointment, TSelectedSkuItem } from "@elixir/types";
import { useEffect, useState } from "react";
import { Popover } from "antd";
import { StethoscopeRegularIcon } from "@elixir/icons";
import { OptionsSelectUi } from "ui";
import { updateAppointment } from "../../../../utils/bridges/methods";
import {
  FirebaseAppointment,
  ServiceItemForAppointment,
} from "../../../../firestore/types";
import ServicesPopup from "../../../cards/queue/services-popup";
import { getServicesOfAppointment } from "../../../../organisms/appointments-v2/get-services-of-appointment";
import usePostCreateServicesMaster from "../../../../apis/axon/services/use-post-create-services-master";

const AddServicesToAppointment = ({
  apt,
  className,
  numberOfChipsToShow = 1,
}: {
  apt: Appointment;
  className?: string;
  numberOfChipsToShow?: number;
}) => {
  const { aid, clinic_id } = apt;
  const [services, setServices] = useState<ServiceItemForAppointment[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const { mutateAsync: postCreateService } = usePostCreateServicesMaster({
    clinic_id: clinic_id as string,
  });


  useEffect(() => {
    const fetchServices = async () => {
      try {
        const aptServices = await getServicesOfAppointment({
          appointment: apt as unknown as FirebaseAppointment,
        });
        aptServices && setServices(aptServices);
      } catch (e) {
        console.error("Error fetching services for appointment", e);
      }
    };
    fetchServices();
  }, [aid]);

  const handleAddService = async (serviceSku: TSelectedSkuItem) => {
    const existingIndex = services.findIndex(
      (s) => s.service_id === serviceSku.service_id
    );

    let updatedServices: ServiceItemForAppointment[];
    if (existingIndex >= 0) {
      updatedServices = services.filter(
        (s) => s.service_id !== serviceSku.service_id
      );
    } else {
      updatedServices = [
        ...services,
        {
          service_name: serviceSku.service_name,
          service_id: serviceSku.service_id!,
          price: serviceSku.price,
        },
      ];
    }

    setServices(updatedServices);
    await updateAppointment({
      data: { services: updatedServices },
      aid,
    });
  };

  const handleCreateNewService = async (serviceSku: TSelectedSkuItem) => {
    await postCreateService({
      price: serviceSku.price || 0,
      service_name: serviceSku.service_name,
      clinic_id: clinic_id as string || localStorage.getItem("selectedClinicId")!,
    });
  };

  return (
    <Popover
      placement="rightTop"
      trigger="click"
      className={`dr-cursor-pointer ${className || ""}`}
      open={showPopup}
      onOpenChange={(value) => setShowPopup(value)}
      content={
        <ServicesPopup
          onClose={() => setShowPopup(false)}
          selectedServiceSkus={services.map((s) => ({
            service_name: s.service_name,
            service_id: s.service_id,
            price: s.price,
          }))}
          handleOnServiceClick={handleAddService}
          onCreateNewService={handleCreateNewService}
        />
      }
      destroyTooltipOnHide={true}
      overlayClassName="fd-popup"
    >
      <>
        <OptionsSelectUi
          Icon={
            <StethoscopeRegularIcon
              className={`dr-w-16 dr-min-w-16 ${
                services.length === 0
                  ? "dr-text-darwin-primary-primary"
                  : "dr-text-darwin-neutral-400"
              }`}
            />
          }
          title="Add Services"
          options={services.map((s) => ({
            option_id: s?.service_id?.toString(),
            label: s?.service_name,
            hex: "rgb(33 95 255)", // dr-text-darwin-primary-primary
            bg_hex: "rgb(233 239 255)", // dr-bg-darwin-primary-bg-light
          }))}
          selectedOptions={services.map((s) => s?.service_id?.toString())}
          numberOfChipsToShow={numberOfChipsToShow}
          extraClass={className}
        />
      </>
    </Popover>
  );
};

export default AddServicesToAppointment;
